export enum Favicon {
    VITA_STUDENT = '/favicon.ico',
    HOUSE_OF_SOCIAL = '/hos-favicon.ico',
}
